export default "__VITE_ASSET__1XRd0IP1__"